export default "__VITE_ASSET__n_bFe6qR__"